module.exports = function (app) {
    require("./vision-health/vision-wellness.js")(app);
    require("./vision-health/vision-library.js")(app);
    require("./vision-health/vision-library-content.js")(app);

    app.controller("pages.vision-health.davisSSO", ["$scope", "$state", "services", "aemContent", "$q", "$sce", "sessionData", "$timeout", "invisibleFormService", "$window", "modal", function($scope, $state, services, aemContent, $q, $sce, sessionData, $timeout, invisibleFormService, $window, modal){
        var ssoInfo = {
            ssoMemberInfo: "",
            verifyKey:"",
            forwardPage:"",
            groupNumber:sessionData.groupNumber,
            umGrp:"1"
        }
        $scope.davisSSOUrl = "";

        if(window.location.hostname.indexOf("env") > -1){
            $scope.davisSSOUrl = $sce.trustAsResourceUrl("https://idoc-cvwebdemo1.davisvision.com/DavisVision.Member/Highmark/Authentication/HighmarkHandoff");
        }else{
            $scope.davisSSOUrl = $sce.trustAsResourceUrl("https://idoc.davisvision.com/DavisVision.Member/Highmark/Authentication/HighmarkHandoff");
        }


        //Davis Vision Forward Page Logic
        if($state.$current.name == "vision-health.vision-claims"){
            ssoInfo.forwardPage = "CLAIMSHISTORY";
        }else if($state.$current.name == "vision-health.vision-eligibility"){
            ssoInfo.forwardPage = "CHECKVISIONELIGIBILITY";
        }else if($state.$current.name == "vision-health.laser-vision"){
            ssoInfo.forwardPage = "LASERVISIONCORRECTION";
        }
        services.rbsmbl.visionSso().get().then(function(response){
            var payload = response.data.payload;
            ssoInfo.ssoMemberInfo = payload.ssoMemberInfo;
            ssoInfo.verifyKey = payload.verifyKey;
            $scope.ssoInfo = ssoInfo;

            $timeout(function(){
                document.getElementById("davis-form").submit();
            },500);
        }, function (error) {
        });
    }]);

    app.controller("pages.vision-health", ["$scope", "$state", "services", "aemContent", "$q", "$sce", "sessionData", "$timeout", "invisibleFormService", "$window", "modal", function($scope, $state, services, aemContent, $q, $sce, sessionData, $timeout, invisibleFormService, $window, modal){

        $scope.headings = "Vision Health & Wellness";
        $scope.backText = "Back";
        $scope.backAction = function () {
            $state.go("^");
        };

        $scope.sidebar.links = [];
        var visionUrl = "";
        var navLinks = [
            aemContent.get("MBR_VISION_HEALTH_NAVIGATION_LINK1"),
            aemContent.get("MBR_VISION_HEALTH_NAVIGATION_LINK2"),
            aemContent.get("MBR_VISION_HEALTH_NAVIGATION_LINK3"),
            aemContent.get("MBR_VISION_HEALTH_NAVIGATION_LINK4"),
            aemContent.get("MBR_VISION_HEALTH_NAVIGATION_LINK5"),
            aemContent.get("MBR_VISION_HEALTH_NAVIGATION_LINK6"),
            aemContent.get("MBR_VISION_HEALTH_NAVIGATION_LINK7")
         ];

        var popVisionModal =  function() {
            modal.open({
                templateUrl: '_modals/visionModal.appTemplate.html/chmhom/modals/visionModal',
                scope: $scope
            })
        };

        //for testing purposes in chrome
        //var usingIE = navigator.userAgent.indexOf('Chrome') > -1;
        var usingIE = navigator.userAgent.indexOf('MSIE')!==-1|| navigator.userAgent.indexOf('Trident/') > 0;

        $q.all(navLinks).then(function (results) {
        var myLinks = ["vision-health.vision-library",
                    "vision-health.vision-claims",
                    "vision-health.eye-care-provider",
                    "vision-health.vision-eligibility",
                    "vision-health.laser-vision"];
            angular.forEach(results, function(value){
                try {
                    var jsonValue = JSON.parse(value);
                    if (myLinks.indexOf(jsonValue.state) > -1 && usingIE) {
                        $scope.sidebar.links.push({
                            label: "<span>" + jsonValue.label + "</span>",
                                onClick: function () {
                                    popVisionModal();
                                }
                            })
                    }else{
                        $scope.sidebar.links.push(jsonValue);
                        }
                    } catch(e) {}
            });
        });

        $scope.isUsingIE = function(){
           if (usingIE){
               popVisionModal();
           }
        };



        //Find eye care provider iframe
        aemContent.get("MBR_VISION_HEALTH_FINDPROVIDER").then(function(response) {
            var jsonResponse = JSON.parse(response);
            $scope.visionUrl = $sce.trustAsResourceUrl(jsonResponse.href);
        });

        $scope.nav = function(state){
            $state.go(state);
        };

        $scope.iframeSrc = function(){
            aemContent.get("MBR_VISION_HEALTH_FINDPROVIDER").then(function(response) {
                var jsonResponse = JSON.parse(response);
                visionUrl = jsonResponse.href;
                return visionUrl;
            });
         };
    }]);

    return [
        {
            state: "vision-health",
            postPassword:true,
            url: "/vision-health",
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/categoryCustom.html"],
                    controller: "pages.vision-health"
                },
                "content@vision-health":{
                    templateUrl: 'vision-health.appTemplate.html/chmhom/pages/vision-health/vision-wellness',
                    controller: "pages.vision-health.vision-wellness"
                }
            }
        },
        {
            state: "vision-health.vision-claims",
            postPassword:true,
            url: "/vision-claims",
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/categoryCustom.html"],
                    controller: "pages.vision-health"
                },
                "content@vision-health.vision-claims":{
                    templateUrl: 'vision-health.appTemplate.html/chmhom/pages/vision-health/vision-claims',
                    controller: "pages.vision-health.davisSSO"
                }
            }
        },
        {
            state: "vision-health.eye-care-provider",
            postPassword:true,
            url: "/eye-care-provider",
            views: {
                "content@vision-health":{
                    templateUrl: 'vision-health.appTemplate.html/chmhom/pages/vision-health/eye-care-provider'
                }
            }
        },
        {
            state: "vision-health.vision-eligibility",
            postPassword:true,
            url: "/vision-eligibility",
            views: {
                "content@vision-health":{
                    templateUrl: 'vision-health.appTemplate.html/chmhom/pages/vision-health/vision-eligibility',
                    controller: "pages.vision-health.davisSSO"
                }
            }
        },
        {
            state: "vision-health.laser-vision",
            postPassword:true,
            url: "/laser-vision",
            views: {
                "content@vision-health":{
                    templateUrl: 'vision-health.appTemplate.html/chmhom/pages/vision-health/laser-vision',
                    controller: "pages.vision-health.davisSSO"
                }
            }
        },
        {
            state: "vision-health.vision-library",
            postPassword:true,
            url: "/vision-wellness-library",
            views: {
                'content@vision-health':{
                    templateUrl: 'vision-health.appTemplate.html/chmhom/pages/vision-health/vision-library',
                    controller: "pages.vision-health.vision-library"
                }
            }
        },
        {
            state: "vision-health.vision-library.article",
            postPassword: true,
            url: "/:articleID",
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/detail.html"],
                    controller: "pages.vision-health"
                },
                "content@vision-health.vision-library.article": {
                    templateUrl: 'vision-health.appTemplate.html/chmhom/pages/vision-health/vision-library-content',
                    controller: "pages.vision-health.vision-library.vision-library-content"
                }
            }
        }
    ]

};

